<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 报表定制  -->
            <el-tab-pane :label="$t('logs.report1')">
                <div class="switch1">
                    <div class="main">
                        <p>
                            <el-alert :title="this.report_build_hint" type="warning" show-icon :closable="false" v-loading="loading"></el-alert>
                        </p>
                    </div>
                    <div class="lie">
                        <table>
                            <tbody>
                                <!-- 日期-->
                                <tr>
                                    <td> {{ $t("logs.report18") }}:</td>
                                    <td>
                                        <el-date-picker v-model="seldate" type="date" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="report18">
                                        </el-date-picker>
                                    </td>
                                </tr>
                                <!-- 发信-->
                                <tr>
                                    <td>{{ $t("logs.report3") }}:</td>
                                    <td class="find-checkbox">
                                        <el-checkbox v-model="local_user_send" @change="CheckChange1">{{ $t("logs.report7") }}</el-checkbox>
                                        <el-checkbox v-model="outer_user_send " @change="CheckChange1">{{ $t("logs.report8") }}</el-checkbox>
                                        <el-checkbox v-model="local_dn_send" @change="CheckChange1">{{ $t("logs.report9") }}</el-checkbox>
                                        <el-checkbox v-model="outer_dn_send" @change="CheckChange1">{{ $t("logs.report10") }}</el-checkbox>
                                    </td>
                                </tr>
                                <!-- 收信-->
                                <tr>
                                    <td>{{ $t("logs.report4") }}</td>
                                    <td class="find-checkbox">
                                        <el-checkbox v-model=" local_user_rcv" @change="CheckChange1">{{ $t("logs.report7") }}</el-checkbox>
                                        <el-checkbox v-model="  outer_user_rcv" @change="CheckChange1">{{ $t("logs.report8") }}</el-checkbox>
                                        <el-checkbox v-model="local_dn_rcv" @change="CheckChange1">{{ $t("logs.report9") }}</el-checkbox>
                                        <el-checkbox v-model="outer_dn_rcv" @change="CheckChange1">{{ $t("logs.report10") }}</el-checkbox>
                                    </td>
                                </tr>
                                <!-- ip-->
                                <tr>
                                    <td>{{ $t("logs.report5") }}</td>
                                    <td class="find-checkbox">
                                        <el-checkbox v-model="ip_stat" @change="CheckChange1">{{ $t("logs.report11") }}</el-checkbox>
                                        <el-checkbox v-model="ip24_sort" @change="CheckChange1">{{ $t("logs.report12") }}</el-checkbox>
                                    </td>
                                </tr>
                                <!--其他-->
                                <tr>
                                    <td>{{ $t("logs.report14") }}</td>
                                    <td class="find-checkbox">
                                        <!-- 融合数据-->
                                        <el-checkbox v-model="merge" v-if="this.SYS_MACHINE_USE_SALT_MASTER==1" @change="CheckChange1">{{ $t("logs.report6") }}</el-checkbox>
                                        <el-checkbox v-model="checkAll1" @change="handleCheckAllChange1">{{ $t("logs.report13") }}</el-checkbox>
                                    </td>
                                </tr>

                                <tr>
                                    <td>{{ $t("logs.report15") }}</td>
                                    <td class="find-checkbox">
                                        <el-input v-model="num" placeholder=""></el-input>
                                    </td>
                                </tr>

                                <!--  <tr>
                                    <td> 发信：</td>
                                    <td class="find-checkbox">
                                        <div v-for="(city,i) in checkedCities1" :key="i">
                                            <label :for="city.checked">
                                                <input type="checkbox" :checked="city.checked" v-model="city.checked" :class="{box2:!city.checked}" @click="isChecked(i)">
                                                {{city .label}}
                                            </label>
                                        </div>

                                    </td>
                                </tr>-->
                                <!-- iP-->
                                <!-- <tr>
                                    <td> 发信：</td>
                                    <td class="find-checkbox">
                                        <el-checkbox @change="selects(item)" v-for="(item, index) in select" :value="item.value" :key="index" :label="item.label">{{item.label}}</el-checkbox>
                                        <input type="checkbox" @click="checkAll" :class="{box2:isCheckAll}">全选
                                    </td>
                                </tr>-->
                                <tr>
                                    <td></td>
                                    <td class="find-checkbox">
                                        <el-button type="primary" @click="download" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.report16") }}</el-button>
                                        <el-select v-model="selecttype" placeholder="" style="width:30%">
                                            <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </td>
                                </tr>
                                <!--   <tr>
                                    <td> </td>
                                    <td class="find-checkbox">
                                        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                                            <el-checkbox v-for="city in cities" :label="city.id" :key="city.id">{{city.label}}</el-checkbox>
                                        </el-checkbox-group>
                                    </td>
                                </tr>
                                <tr>
                                    <td> </td>
                                    <td class="find-checkbox">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                    </td>
                                </tr>-->
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-tab-pane>
            <!-- 排程定制 -->
            <el-tab-pane :label="$t('logs.report2')">
                <div class="switch1">
                    <div class="main">
                        <p>
                            <el-alert :title="this.schedule_build_hint" type="warning" show-icon :closable="false"></el-alert>
                        </p>
                    </div>
                    <div class="lie">
                        <table>
                            <tbody>
                                <!-- 日期-->
                                <tr>
                                    <td> {{ $t("logs.report17") }}:</td>
                                    <td>
                                        <el-input v-model="receive_email" placeholder="请输入内容"></el-input>
                                    </td>
                                </tr>
                                <!-- 发信-->
                                <tr>
                                    <td>{{ $t("logs.report3") }}:</td>
                                    <td class="find-checkbox">
                                        <el-checkbox v-model="has_local_user_send" @change="CheckChange2">{{ $t("logs.report7") }}</el-checkbox>
                                        <el-checkbox v-model=" has_outer_user_send" @change="CheckChange2">{{ $t("logs.report8") }}</el-checkbox>
                                        <el-checkbox v-model=" has_local_dn_send" @change="CheckChange2">{{ $t("logs.report9") }}</el-checkbox>
                                        <el-checkbox v-model="has_outer_dn_send" @change="CheckChange2">{{ $t("logs.report10") }}</el-checkbox>
                                    </td>
                                </tr>
                                <!-- 收信-->
                                <tr>
                                    <td>{{ $t("logs.report4") }}</td>
                                    <td class="find-checkbox">
                                        <el-checkbox v-model="has_local_user_rcv" @change="CheckChange2">{{ $t("logs.report7") }}</el-checkbox>
                                        <el-checkbox v-model=" has_outer_user_rcv" @change="CheckChange2">{{ $t("logs.report8") }}</el-checkbox>
                                        <el-checkbox v-model=" has_local_dn_rcv" @change="CheckChange2">{{ $t("logs.report9") }}</el-checkbox>
                                        <el-checkbox v-model="has_outer_dn_rcv" @change="CheckChange2">{{ $t("logs.report10") }}</el-checkbox>
                                    </td>
                                </tr>
                                <!-- ip-->
                                <tr>
                                    <td>{{ $t("logs.report5") }}</td>
                                    <td class="find-checkbox">
                                        <el-checkbox v-model="has_ip_stat" @change="CheckChange2">{{ $t("logs.report11") }}</el-checkbox>
                                        <el-checkbox v-model="has_ip24_sort" @change="CheckChange2">{{ $t("logs.report12") }}</el-checkbox>
                                    </td>
                                </tr>
                                <!--其他-->
                                <tr>
                                    <td>{{ $t("logs.report14") }}</td>
                                    <td class="find-checkbox">
                                        <!-- 融合数据-->
                                        <el-checkbox v-model="has_merge" v-if="this.SYS_MACHINE_USE_SALT_MASTER==1" @change="CheckChange2">{{ $t("logs.report6") }}</el-checkbox>
                                        <el-checkbox v-model="has_html" @change="CheckChange2">HTML</el-checkbox>
                                        <el-checkbox v-model="has_pdf" @change="CheckChange2">PDF</el-checkbox>
                                        <el-checkbox v-model="checkAll2" @change="handleCheckAllChange2">{{ $t("logs.report13") }}</el-checkbox>
                                    </td>
                                </tr>

                                <tr>
                                    <td>{{ $t("logs.report15") }}</td>
                                    <td class="find-checkbox">
                                        <el-input v-model="set_num" placeholder=""></el-input>
                                    </td>
                                </tr>

                                <!--  <tr>
                                    <td> 发信：</td>
                                    <td class="find-checkbox">
                                        <div v-for="(city,i) in checkedCities1" :key="i">
                                            <label :for="city.checked">
                                                <input type="checkbox" :checked="city.checked" v-model="city.checked" :class="{box2:!city.checked}" @click="isChecked(i)">
                                                {{city .label}}
                                            </label>
                                        </div>

                                    </td>
                                </tr>-->
                                <!-- iP-->
                                <!-- <tr>
                                    <td> 发信：</td>
                                    <td class="find-checkbox">
                                        <el-checkbox @change="selects(item)" v-for="(item, index) in select" :value="item.value" :key="index" :label="item.label">{{item.label}}</el-checkbox>
                                        <input type="checkbox" @click="checkAll" :class="{box2:isCheckAll}">全选
                                    </td>
                                </tr>-->
                                <tr>
                                    <td></td>
                                    <td class="find-checkbox">
                                        <el-button type="primary" @click="save_schedule" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.save_a") }}</el-button>

                                    </td>
                                </tr>
                                <!--   <tr>
                                    <td> </td>
                                    <td class="find-checkbox">
                                        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                                            <el-checkbox v-for="city in cities" :label="city.id" :key="city.id">{{city.label}}</el-checkbox>
                                        </el-checkbox-group>
                                    </td>
                                </tr>
                                <tr>
                                    <td> </td>
                                    <td class="find-checkbox">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                    </td>
                                </tr>-->
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
const cityOptions = [{
    "label": "本地用户",
    "id": "0",
}, {
    "label": "外部用户",
    "id": "1",
}, {
    "label": "本地域",
    "id": "2",
}, {
    "label": "外部域",
    "id": "3",
}];

const cityOptions1 = ["本地用户", "外部用户", "本地域", "外部域"];
const cityOptions2 = ["IP", "IP段"];
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    // return time.getTime() > Date.now();
                    return time.getTime() > (Date.now() - (24 * 60 * 60 * 1000));
                },
            },
            selecttype: 'pdf',
            seldate: '',
            loading: false,
            data_loadok: '',
            SYS_MACHINE_USE_SALT_MASTER: '',
            report_build_hint: '',
            schedule_build_hint: '',
            has_merge: false,
            has_local_user_send: false,
            has_local_user_rcv: false,
            has_outer_user_send: false,
            has_outer_user_rcv: false,
            has_local_dn_send: false,
            has_local_dn_rcv: false,
            has_outer_dn_send: false,
            has_outer_dn_rcv: false,
            has_ip_stat: false,
            has_ip24_sort: false,
            has_html: false,
            has_pdf: false,
            set_num: '',
            // 报表定制
            merge: false,
            local_user_send: false,
            local_user_rcv: false,
            outer_user_send: false,
            outer_user_rcv: false,
            local_dn_send: false,
            local_dn_rcv: false,
            outer_dn_send: false,
            outer_dn_rcv: false,
            ip_stat: false,
            ip24_sort: false,
            num: '',
            checked_first: false,
            checked_second: false,
            printnum: '',

            checked: '',
            checkAll: false,
            checkAll1: false,
            checkAll2: false,

            cities: cityOptions,
            // isIndeterminate: true,
            isCheckAll: false,
            receive_email: '',
            value1: "",
            // checkAll: false,

            // checkAll2: false,
            checkedCities: [],
            checkedCities1: [{
                "label": "本地用户",
                "checked": false,
            }, {
                "label": "外部用户",
                "checked": false,
            }, {
                "label": "本地域",
                "checked": false,
            }, {
                "label": "外部域",
                "checked": true,
            }],
            checkedCities2: [],

            cities1: cityOptions1,
            cities2: cityOptions2,

            isIndeterminate1: false,
            isIndeterminate2: false,
            list: [{
                    label: 'pdf',
                    value: 'pdf'
                },
                {
                    label: 'html',
                    value: 'html'
                },
                // {
                //     label: '手机',
                //     checked: false
                // },
            ],
            select: [{
                    label: '外部',
                    value: false
                },
                {
                    label: '内部',
                    value: false
                },
                {
                    label: '全选',
                    value: false
                }
            ],

        };
    },
    mounted() {
        this.getFileList()
    },
    methods: {
        // 保存
        save_schedule() {
            this.$save_hint_test();
            this.$disable_hint_test();
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_schedule_build",
                sid: sid,
                data_loadok: this.data_loadok,
                has_html: this.has_html == true ? 1 : 0,
                has_pdf: this.has_pdf == true ? 1 : 0,
                has_outer_user_send: this.has_outer_user_send == true ? 1 : 0,
                has_outer_user_rcv: this.has_outer_user_rcv == true ? 1 : 0,
                has_outer_dn_send: this.has_outer_dn_send == true ? 1 : 0,
                has_outer_dn_rcv: this.has_outer_dn_rcv == true ? 1 : 0,
                has_merge: this.has_merge == true ? 1 : 0,
                has_local_user_send: this.has_local_user_send == true ? 1 : 0,
                has_local_user_rcv: this.has_local_user_rcv == true ? 1 : 0,
                has_local_dn_send: this.has_local_dn_send == true ? 1 : 0,
                has_local_dn_rcv: this.has_local_dn_rcv == true ? 1 : 0,
                has_ip_stat: this.has_ip_stat == true ? 1 : 0,
                has_ip24_sort: this.has_ip24_sort == true ? 1 : 0,
                receive_email: this.receive_email,
                set_num: this.set_num,

            });
            this.$axios
                .post("/api/adm/cgi/report.cgi", str)
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList()
                        this.loading = false;
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        // 下载统计数据
        download() {
            // console.log(this.selecttype, '文件类型')
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "create_report";
            // let __mode1 = "cmd_print_eachday_stat";
            let local_user_send = this.local_user_send == true ? 1 : 0
            let local_user_rcv = this.local_user_rcv == true ? 1 : 0
            let outer_user_send = this.outer_user_send == true ? 1 : 0
            let outer_user_rcv = this.outer_user_rcv == true ? 1 : 0
            let local_dn_send = this.local_dn_send == true ? 1 : 0
            let local_dn_rcv = this.local_dn_rcv == true ? 1 : 0
            let outer_dn_send = this.outer_dn_send == true ? 1 : 0
            let outer_dn_rcv = this.outer_dn_rcv == true ? 1 : 0
            let ip_stat = this.ip_stat == true ? 1 : 0
            let ip24_sort = this.ip24_sort == true ? 1 : 0
            let printtype = this.selecttype
            let date = this.seldate
            let num = this.num
            let merge = this.merge == true ? 1 : 0
            // console.log(date);
            // console.log(outer_user_rcv);
            // console.log(outer_user_send);
            // console.log(local_dn_send);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/report.cgi?__mode=${__mode}&sid=${sid}&local_user_send=${local_user_send}&local_user_rcv=${local_user_rcv}&outer_user_send=${outer_user_send}&outer_user_rcv=${outer_user_rcv}&local_dn_send=${local_dn_send}&local_dn_rcv=${local_dn_rcv}&outer_dn_send=${outer_dn_send}&outer_dn_rcv=${outer_dn_rcv}&ip_stat=${ip_stat}&ip24_sort=${ip24_sort}&printtype=${printtype}&date=${date}&num=${num}&merge=${merge}`);

        },
        // 加载
        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/report.cgi", {
                    params: {
                        __mode: "load_schedule_build",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.fileList2 = res.data.ret.datalist;
                        this.report_build_hint = res.data.ret.report_build_hint
                        this.schedule_build_hint = res.data.ret.schedule_build_hint
                        this.data_loadok = res.data.ret.ok
                        this.SYS_MACHINE_USE_SALT_MASTER = res.data.ret.SYS_MACHINE_USE_SALT_MASTER

                        this.num = 10
                        this.set_num = res.data.ret.result.num
                        this.seldate = res.data.ret.date
                        this.receive_email = res.data.ret.result.receive_email
                        this.has_ip24_sort = res.data.ret.result.has_ip24_sort == 1 ? true : false
                        this.has_ip_stat = res.data.ret.result.has_ip_stat == 1 ? true : false
                        this.has_local_dn_rcv = res.data.ret.result.has_local_dn_rcv == 1 ? true : false
                        this.has_local_dn_send = res.data.ret.result.has_local_dn_send == 1 ? true : false
                        this.has_local_user_rcv = res.data.ret.result.has_local_user_rcv == 1 ? true : false
                        this.has_local_user_send = res.data.ret.result.has_local_user_send == 1 ? true : false
                        this.has_merge = res.data.ret.result.has_merge == 1 ? true : false
                        this.has_outer_dn_rcv = res.data.ret.result.has_outer_dn_rcv == 1 ? true : false
                        this.has_outer_dn_send = res.data.ret.result.has_outer_dn_send == 1 ? true : false
                        this.has_outer_user_rcv = res.data.ret.result.has_outer_user_rcv == 1 ? true : false
                        this.has_outer_user_send = res.data.ret.result.has_outer_user_send == 1 ? true : false
                        this.has_pdf = res.data.ret.result.has_pdf == 1 ? true : false
                        this.has_html = res.data.ret.result.has_html == 1 ? true : false

                        this.loading = false;

                    }
                })
               
        },
        CheckChange1() {
            this.handleCheckChange1()

        },
        CheckChange2() {
            this.handleCheckChange2()

        },
        // 报表定制全选或者不选 判断
        handleCheckChange2() {
            if (this.has_merge == false ||
                this.has_local_user_send == false ||
                this.has_local_user_rcv == false ||
                this.has_outer_user_send == false ||
                this.has_outer_user_rcv == false ||
                this.has_local_dn_send == false ||
                this.has_local_dn_rcv == false ||
                this.has_outer_dn_send == false ||
                this.has_outer_dn_rcv == false ||
                this.has_ip_stat == false ||
                this.has_html == false ||
                this.has_pdf == false ||
                this.has_ip24_sort == false) {
                this.checkAll2 = false
            } else {
                this.checkAll2 = true

            }
        },
        handleCheckChange1() {
            if (this.merge == false ||
                this.local_user_send == false ||
                this.local_user_rcv == false ||
                this.outer_user_send == false ||
                this.outer_user_rcv == false ||
                this.local_dn_send == false ||
                this.local_dn_rcv == false ||
                this.outer_dn_send == false ||
                this.outer_dn_rcv == false ||
                this.ip_stat == false ||
                this.ip24_sort == false) {
                this.checkAll1 = false
            } else {
                this.checkAll1 = true

            }
        },

        // 报表定制全选或者不选
        handleCheckAllChange2(val) {
            console.log(val)
            this.checked_second = val
            if (val == false) {
                // this.isIndeterminate = false;

                this.has_merge = false,
                    this.has_local_user_send = false,
                    this.has_local_user_rcv = false,
                    this.has_outer_user_send = false,
                    this.has_outer_user_rcv = false,
                    this.has_local_dn_send = false,
                    this.has_local_dn_rcv = false,
                    this.has_outer_dn_send = false,
                    this.has_outer_dn_rcv = false,
                    this.has_ip_stat = false,
                    this.has_ip24_sort = false
                this.has_html = false
                this.has_pdf = false

            } else {
                // this.isIndeterminate = true;
                this.has_merge = true,
                    this.has_local_user_send = true,
                    this.has_local_user_rcv = true,
                    this.has_outer_user_send = true,
                    this.has_outer_user_rcv = true,
                    this.has_local_dn_send = true,
                    this.has_local_dn_rcv = true,
                    this.has_outer_dn_send = true,
                    this.has_outer_dn_rcv = true,
                    this.has_ip_stat = true,
                    this.has_ip24_sort = true,
                    this.has_html = true
                this.has_pdf = true
            }

        },
        handleCheckAllChange1(val) {
            console.log(val)
            this.checked_first = val
            if (val == false) {
                // this.isIndeterminate = false;

                this.merge = false,
                    this.local_user_send = false,
                    this.local_user_rcv = false,
                    this.outer_user_send = false,
                    this.outer_user_rcv = false,
                    this.local_dn_send = false,
                    this.local_dn_rcv = false,
                    this.outer_dn_send = false,
                    this.outer_dn_rcv = false,
                    this.ip_stat = false,
                    this.ip24_sort = false

            } else {
                // this.isIndeterminate = true;
                this.merge = true,
                    this.local_user_send = true,
                    this.local_user_rcv = true,
                    this.outer_user_send = true,
                    this.outer_user_rcv = true,
                    this.local_dn_send = true,
                    this.local_dn_rcv = true,
                    this.outer_dn_send = true,
                    this.outer_dn_rcv = true,
                    this.ip_stat = true,
                    this.ip24_sort = true
            }

        },
        handleCheckAllChange(val) {
            this.checkedCities = val ? cityOptions.map(ele => ele.id) : [];
            this.isIndeterminate = false;
            console.log(val)
            console.log(this.checkedCities, '全选')

        },
        handleCheckedCitiesChange(value) {
            console.log(value)
            console.log(this.checkedCities, '1111111')
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },
        selects(item) {
            if (item.label === '全选') {
                this.selectAll(item.value)
            } else {
                let all = true
                let arr = this.select.filter(ele => ele.label !== '全选')
                for (const i of arr) {
                    if (i.label === item.label) {
                        i.value = !i.value
                    }
                    if (!i.value) all = false
                }
                if (all) {
                    this.selectAll(false)
                } else {
                    for (const i of this.select) {
                        if (i.label === '全选') {
                            i.value = false
                        }
                    }
                }
            }
        },
        selectAll(value) {
            for (const i of this.select) {
                if (value) {
                    i.value = false
                } else {
                    i.value = true
                }
            }
        },
        // checkAll() {
        //     this.isCheckAll = !this.isCheckAll
        //     this.checkedCities1.forEach(ele => {
        //         ele.checked = this.isCheckAll
        //     })
        // },
        isChecked(index) {
            this.checkedCities1[index].checked = !this.checkedCities1[index].checked;
            let num = 0;
            this.checkedCities1.forEach(ele => {
                if (ele.checked) {
                    num++
                }
            })
            this.isCheckAll = (num == this.checkedCities1.length)
            console.log(this.checkedCities1, '111')
            console.log(index, '222')
        }

    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

.find-checkbox {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    line-height: 48px;
    // height: 50px;
}

.lie .el-checkbox-group {
    line-height: 0;
}

.el-checkbox {
    margin-right: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #0e2c5e;
}

.box {
    width: 10px;
    height: 10px;
    line-height: 10px;
    font-size: 15px;
    border: 1px solid cornflowerblue;
    background: cornflowerblue;
    color: #fff;
    user-select: none;
}

.box1 {
    transform: rotate(130deg) translate(-1px, 1px);
}

.box2 {
    background: #fff;
}
.report18{
   /deep/ .el-input__inner{
        padding-left: 30px;
    }
}
</style>
